// Actions
import {
  SET_EVENT_LISTENER_HAS_BEEN_ATTACHED,
  SET_GOOD_DATA_EVENT,
  SET_PLATFORM_INFO_EVENT,
  SET_FILTER_VALUE_CHANGE_EVENT,
  SET_UI_DRILL_EVENT,
  SET_DATE_RANGE,
  SET_USER_BROWSER,
} from '../actionTypes/goodData.actionTypes';

export interface ISetGoodDataEventListenerAction {
  type: string;
  payload: boolean;
}

export function setEventListenerHasBeenAttached(
  value: boolean
): ISetGoodDataEventListenerAction {
  return { type: SET_EVENT_LISTENER_HAS_BEEN_ATTACHED, payload: value };
}

export interface ISetGoodDataEventAction {
  type: string;
  payload: any;
}

export function setGoodDataEvent(value: any): ISetGoodDataEventAction {
  return { type: SET_GOOD_DATA_EVENT, payload: value };
}

export function setPlatformInfoEvent(
  value: boolean
): ISetGoodDataEventListenerAction {
  return { type: SET_PLATFORM_INFO_EVENT, payload: value };
}

export function setFilterValueChangeEvent(
  value: boolean
): ISetGoodDataEventListenerAction {
  return { type: SET_FILTER_VALUE_CHANGE_EVENT, payload: value };
}

export function setUIDrillEvent(
  value: boolean
): ISetGoodDataEventListenerAction {
  return { type: SET_UI_DRILL_EVENT, payload: value };
}

export interface ISetGoodDataDateRangeAction {
  type: string;
  payload: {
    selection: {
      label: string;
      value: number;
    };
    fromDate: string;
    toDate: string;
  };
}

export function setDateRange(value: {
  selection: {
    label: string;
    value: number;
  };
  fromDate: string;
  toDate: string;
}): ISetGoodDataDateRangeAction {
  return { type: SET_DATE_RANGE, payload: value };
}

interface ISetUserBrowserAction {
  type: string;
  payload: {
    name: string;
    version: string;
  };
}

export function setUserBrowser(value: {
  name: string;
  version: string;
}): ISetUserBrowserAction {
  return { type: SET_USER_BROWSER, payload: value };
}
try {
    // @ts-ignore
    setEventListenerHasBeenAttached.displayName = "setEventListenerHasBeenAttached";
    // @ts-ignore
    setEventListenerHasBeenAttached.__docgenInfo = { "description": "", "displayName": "setEventListenerHasBeenAttached", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setEventListenerHasBeenAttached"] = { docgenInfo: setEventListenerHasBeenAttached.__docgenInfo, name: "setEventListenerHasBeenAttached", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setEventListenerHasBeenAttached" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setGoodDataEvent.displayName = "setGoodDataEvent";
    // @ts-ignore
    setGoodDataEvent.__docgenInfo = { "description": "", "displayName": "setGoodDataEvent", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setGoodDataEvent"] = { docgenInfo: setGoodDataEvent.__docgenInfo, name: "setGoodDataEvent", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setGoodDataEvent" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setPlatformInfoEvent.displayName = "setPlatformInfoEvent";
    // @ts-ignore
    setPlatformInfoEvent.__docgenInfo = { "description": "", "displayName": "setPlatformInfoEvent", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setPlatformInfoEvent"] = { docgenInfo: setPlatformInfoEvent.__docgenInfo, name: "setPlatformInfoEvent", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setPlatformInfoEvent" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setFilterValueChangeEvent.displayName = "setFilterValueChangeEvent";
    // @ts-ignore
    setFilterValueChangeEvent.__docgenInfo = { "description": "", "displayName": "setFilterValueChangeEvent", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setFilterValueChangeEvent"] = { docgenInfo: setFilterValueChangeEvent.__docgenInfo, name: "setFilterValueChangeEvent", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setFilterValueChangeEvent" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setUIDrillEvent.displayName = "setUIDrillEvent";
    // @ts-ignore
    setUIDrillEvent.__docgenInfo = { "description": "", "displayName": "setUIDrillEvent", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setUIDrillEvent"] = { docgenInfo: setUIDrillEvent.__docgenInfo, name: "setUIDrillEvent", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setUIDrillEvent" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setDateRange.displayName = "setDateRange";
    // @ts-ignore
    setDateRange.__docgenInfo = { "description": "", "displayName": "setDateRange", "props": { "selection": { "defaultValue": null, "description": "", "name": "selection", "required": true, "type": { "name": "{ label: string; value: number; }" } }, "fromDate": { "defaultValue": null, "description": "", "name": "fromDate", "required": true, "type": { "name": "string" } }, "toDate": { "defaultValue": null, "description": "", "name": "toDate", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setDateRange"] = { docgenInfo: setDateRange.__docgenInfo, name: "setDateRange", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setDateRange" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setUserBrowser.displayName = "setUserBrowser";
    // @ts-ignore
    setUserBrowser.__docgenInfo = { "description": "", "displayName": "setUserBrowser", "props": { "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } }, "version": { "defaultValue": null, "description": "", "name": "version", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setUserBrowser"] = { docgenInfo: setUserBrowser.__docgenInfo, name: "setUserBrowser", path: "src/shared/containers/GoodData/actionCreators/goodData.actionCreators.ts#setUserBrowser" };
}
catch (__react_docgen_typescript_loader_error) { }